module.exports = __webpack_public_path__ + "M2M1.png?a24f0ce0a6fba6c10a9a91dbcec5e552";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/M2M1.png
// module id = 104
// module chunks = 0